const styles = {
  dialog: {
    height: '17rem',
    width: '20rem',
  },
}

export default styles
